import { Box } from "@mui/material";

import { ReactComponent as IconPerfil } from "../../images/iconPerfil.svg";

export default function IconUser({ bgColor = "red" }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxSizing: "border-box",
        width: "80px",
        height: "80px",
        background: bgColor + " !important",
        borderRadius: "50%",
        border: "8px solid #D3E3EB",
        "& path": {
          stroke: "#fff !important",
        },
      }}
    >
      <IconPerfil width="40px" height="40px" fill={bgColor} />
    </Box>
  );
}
